import { AnyPrice } from "@ct-react/core";

export type LocationInput = {
  street: string;
  streetNumber?: string;
  streetComplement?: string;
  zip: string;
  city: string;
  country: string;
}

export type Location = LocationInput & {
  resume?: string;
}

export type BasicPrice = {
  onDemand: boolean;
  value: AnyPrice;
}

export const resumeLocation = (value: Location) => {
  if (!!value.resume) return value.resume;
  let street = value.street;
  if (!!value.streetNumber) street = `${street} ${value.streetNumber}`;
  if (!!value.streetComplement) street = `${street} (${value.streetComplement})`;
  return `${street}, ${value.zip} ${value.city} - ${value.country}`;
}
